<template>
  <div class="outerCtn">
    <img
      src="@/assets/productCenter/a.png"
      alt=""
      srcset=""
      style="width:100%"
    />
    <div class="article">
      <p>软件产品</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
    </div>
    <div class="detail">
      <el-carousel height="420px" arrow="always">
        <el-carousel-item v-for="(item, index) in carouselData" :key="index">
          <p style="font-size: 18px; margin-bottom: 16px">{{ item.title }}</p>
          <img
            :src="item.assets"
            alt=""
            srcset=""
            style="height: 120px"
            @click="tolink(index)"
          />
          <p
            style="
              font-size: 12px;
              line-height: 20px;
              text-align: left;
              margin-top: 20px;
              letter-spacing:1px;
            "
          >
            {{ item.content }}
          </p>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="article">
      <p>硬件产品</p>
      <div class="imgCtn">
        <img src="@/assets/home_line.png" alt="" srcset="" />
      </div>
    </div>
    <div class="detail" style="padding-bottom:20px">
      <el-carousel height="600px" arrow="always">
        <el-carousel-item v-for="(item, index) in hardWareData" :key="index">
          <p style="font-size: 18px; margin-bottom: 25px">{{ item.title }}</p>
          <img
            :src="item.assets"
            alt=""
            srcset=""
            style="height: 120px;margin-bottom:50px"
            @click="tolink(index)"
          />
            <div  class="hardWareText" v-for="items in item.content" :key="items.id">
              <div class="point"></div>
              <p>{{ items.desc }}</p>
            </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import img1 from '../../../assets/productCenter/1.png'
import img2 from '../../../assets/productCenter/2.png'
import img3 from '../../../assets/productCenter/3.png'
import img4 from '../../../assets/productCenter/4.png'
import img5 from '../../../assets/productCenter/5.png'
import img6 from '../../../assets/productCenter/6.png'
import img7 from '../../../assets/productCenter/7.png'
import db from '../../../assets/productCenter/db.png'
import sb from '../../../assets/productCenter/sb.png'
import jz from '../../../assets/productCenter/jz.png'
export default {
  data() {
    return {
      carouselData: [
        {
          title: "能源管理系统",
          assets: img1,
          content:
          "基于小鳗管家能耗监测模块、设备监控模块、业态分析模块，运维管理模块等，实现了能耗采集、数据统计、分项分析、异常诊断、需量分析、故障告警、报表分析等管理功能，人工管控模式所存在的问题和缺陷得到了明显改善，实现精细化用能管理、能源数字化监测和智慧化运维管理。"
        },
        {
          title: "集约能源管理系统",
          assets: img2,
          content:
          "针对集团/区域的能源管理系统，基于基础数据进行自定义指标的汇总和统计；能耗总量和经营数据，计算单位能耗产出和单位面积用能；通过大数据分析，根据月/季度/年度等时间维度进行使用状态的反馈，下发合理的项目配额/预算，用户也可根据经验进行配额配置；对集团所有项目进行横向配额使用和反馈的评估通知，协助管理优化及支撑高层决策向下满足考核指标。"
        },
        {
          title: "计量收费系统",
          assets: img3,
          content:
          "基于预付费智能终端，实现“先缴费后用能、远程分合闸控制、无卡自助充值”的管理模式。计量收费系统实现电能消耗的在线监测和管理，具备网络在线充值，低余额报警、欠费断电等管理手段，并支持智能水表的接入和计费管理，有效解决抄表难、收费难的问题。同时支持物业窗口缴费和移动端自助缴费，商户还能查看用电量明细、分析用能合理性，清晰掌握用电量，大大减少了收费人员的工作量、提升物业服务质量和水平。"
        },
        {
          title: "暖通空调节能算法系统",
          assets: img4,
          content:
            "采用低功耗LORA 无线通讯和数据采集专利技术，实现中央空调集控系统的最轻量化部署；同时基于云端AI 算法和大数据处理技术，在确保室内环境舒适的前提下，对中央空调主机、水泵、冷却塔、电磁阀等设备进行安全与能效的双重监测分析，提供最优化控制策略，实现能效提升、电力需求侧响应和智能运维，帮助企业节能、降本、增效。"
        },
        {
          title: "动力储能回馈系统",
          assets: img5,
          content:
          "采用电梯专用高性能回馈式制动单元。升降电梯在使用电梯回馈节能产品后，能有效的将电池中储存的直流电能再次转换成交流电能回送到电网，节电率达25%-50%.此外，由于无电阻发热元件，降低了机房的环境温度，同时也改善了电梯控制系统的运行温度，使控制系统不再死机，延长电梯使用寿命。机房可以不再使用空调等散热设备，可以节省机房空调和散热设备的耗电量，节能环保，使电梯更省电。在许多场合，节约空调耗电量往往带来更大的节电效果，是新电梯配套、旧电梯改造的首选产品。"
        },
        {
          title: "智慧照明系统",
          assets: img6,
          content:
            "智慧照明系统能实现远程控制，根据需求可以实现远程开关照明；拥有策略管理，根据需求进行区域的开关策略控制，减少跑冒滴漏；可根据需求配置对应的场景进行快速切换（工作日/非工作日；节假日/大型活动日等）；可进行异常诊断，根据能耗和运行数据进行模型分析，及时推送异常用能告警，协助用户主动发现问题，及时解决问题，减少浪费，避免风险扩散；可进行设备管理，实现记录并分析对应照明设备的入场时间，使用时间，更换率等信息和多维协同分析。",
        },
        {
          title: "虚拟电厂运营管理系统",
          assets: img7,
          content:
            "基于能源管理系统/暖通空调系统/智慧照明系统，利用IoT和大数据平台构架，打造了虚拟电厂运营管理系统，通过VPP协助商业运营方参与电力现货市场交易，实现分布式电源、储能微网、储能系统、可控负荷、电动汽车等分布式能源的聚合和协调控制，作为一个特殊电厂参与电力市场和电网运行、接受电网调度指令、参与需求侧响应、提供电网辅助服务。",
        },
      ],
      hardWareData:[
        {
          title: "智能电表",
          assets: db,
          content:[
            {id:11,desc:'采用SMT工艺进行制造，工艺先进，质量可靠；'},
            {id:12,desc:'实现了有功、无功电能双向计量，分相计量以及计量数据的处理和存储，实现了瞬时电压、电流、有功功率、无功功率、视在功率、功率因数、电网频率等运行参数的实时采集；'},
            {id:13,desc:'能自动识别负载的大小，可根据设置负荷限实现对用户超负荷用电进行控制；'},
            {id:14,desc:'具有物理层独立的RS485通信接口或4G无线通讯接口；'},
            {id:15,desc:'充分考虑了电磁兼容、数据安全、抗死机等方面的要求，功能丰富、性能稳定、质量可靠、维护方便，广泛用于办公楼、商业综合体、园区、住宅、学校、酒店、医院等场所。'}
          ]
        },
        {
          title: "智能水表",
          assets: sb,
          content:[
            {id:16,desc:'采用M-bus通讯接口或NB-IoT通讯接口，信号传输稳定,，抄表方式快捷，数据更准确、可靠。'},
            {id:17,desc:'单片机采用高可靠性设计，运行稳定。'},
            {id:18,desc:'独有防气泡工艺，抄读数据成功率高。'},
            {id:19,desc:'不受外界强磁攻击，抗干扰性能极强。'},
            {id:20,desc:'全密封设计，防水性能好。'},
            {id:21,desc:'日常工作无需供电, 使用寿命长。'},
            {id:22,desc:'远传远控水表，可通过系统软件实现预付费功能,开/关阀操作。'},
          ]
        },
        {
          title: "基站产品",
          assets: jz,
          content:[
            {id:23,desc:'导轨安装。'},
            {id:24,desc:'工业级设计，超高可靠性；'},
            {id:25,desc:'多种指示灯反馈设备工作状态；'},
            {id:26,desc:'支持网络升级和双向连续传输数据；'},
            {id:27,desc:'支持APN/VPN 接入，支持短信数据透传；'},
            {id:28,desc:'支持Modbus RTU 和Modbus TCP 互转；'},
            {id:29,desc:'支持4G 全网通，覆盖广、传输延迟低、稳定性高；'},
            {id:30,desc:'支持手机、串口、网络等多种配置方式，串口支持多种波特率；'},
            {id:31,desc:'支持多链路的边缘采集功能，支持Modbus 自动添加CRC 校验；'},
            {id:32,desc:'支持4 路Socket，每条链路独立工作，支持独立20K 超大缓存；'},
            {id:33,desc:'支持多种工作模式，网络透传、MQTT 模式、HTTP 透传、短信透传；'},
            {id:34,desc:'支持快速接入阿里云、百度云、OneNET、3.1 版本标准MQTT 服务器；'},
          ]
        },
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.outerCtn {
  background-image: url('../../../assets/productCenter/Bg.png');
  background-position: center;
  background-size: cover;
  color: white;
  min-height: 100vh;
  .article {
    padding: 40px 20px 20px 20px;
    text-align: left;
    background-color: #121825;
    p {
      font-size: 22px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      padding-bottom: 10px;
      text-align: center;
    }
    .imgCtn {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width:84px;
        height: 3px;
      }
    }
  }
  .detail{
    margin-top: 27px;
    margin: 20px;
    margin-bottom: 0;
    p{
      padding: 0 10%;
    }
  }
  .point{
    width: 10px;
    height: 10px;
    background-color: #3170FF;
    border: 2px solid white;
    transform: rotate(45deg);
    margin-left: 10px;
  }
  .hardWareText{
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    p{
      width: 100%;
      margin: 4px 0;
      letter-spacing: 1px;
      line-height: 16px;
    }
  }
}
</style>
<style>
  .detail .el-carousel__indicator--horizontal{
        display: none;
    }
  .detail .el-carousel__arrow{
        top:20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneProduct.vue